/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import querystring from 'query-string'
import { getQueryVariable } from '@/utils/utils';
import RegisterStep from './components/registerStep'
import { appMap } from './config'
import {
  AppList,
  getArray2Name,
  getWhiteTime,
  sensorsMonitor,
} from '@/utils/utils'
import '@/assets/css/RegisterCoinlist.scss';
// import KeepAlive, { AliveScope } from 'react-activation'
const SaSdk = sensorsMonitor()
// let time = 5
class RegisterCoinlist extends Component {
  constructor(props) {
    super(props);
    const query = querystring.parse(window.location.search)
    const localApp = query['app'] || ''
    let app = getArray2Name(AppList, localApp)
    if (!app) {
      app = AppList[0] // 默认走印度
    }
    this.state = {
      tip: '',
      app: '',
      time: 10,
      appRules: app,
      appContent: {}
    }
  }
  setInfo(){
    const app = getQueryVariable('app')
    const appName = (app || 'default').toLowerCase()
    // 兼容小写
    this.setState({
      app: appName,
      appContent: appMap[appName]// 配置界面中所有的文字
    })
  }

  goToRegister(e) {
    if(this.state.time > 0) {
      e.preventDefault();
    } else {
      // window.android && window.android.openWebBrowser('https://wenjuan.feishu.cn/m?t=sixZLRDzRrzi-g3xh')
      window.location.href = "https://wenjuan.feishu.cn/m?t=sixZLRDzRrzi-g3xh";
      // window.location.href = "intent://wenjuan.feishu.cn/m?t=sixZLRDzRrzi-g3xh#Intent;scheme=http;package=com.android.browser;end";
      SaSdk.track('verify_coinlist_click');
    }
  }
  pushRegister(e) {
    e.preventDefault();
    // window.android && window.android.openWebBrowser('https://coinlist.co')
    window.location.href = "https://coinlist.co";
    // window.location.href = "intent://coinlist.co#Intent;scheme=http;package=com.android.browser;end";
  }
  // aRegister() { 使用app调用外部浏览器时才会使用到的函数
  //   window.android && window.android.openWebBrowser('https://coinlist.co')
  // }
  // 数据打点相关
  sensorsInit() {
    SaSdk.registerPage({
      current_url: window.location.href,
      pagename: 'h5_register_coinlist',
      appName: this.state.appRules.appName,
    })
    SaSdk.quick('autoTrack')
    SaSdk.track('coinlist_open', {
      load_time: getWhiteTime(),
    })
  }

  componentDidMount(){
    // window.aRegister = this.aRegister; // 模板字符串中的链接跳转
    this.setInfo()
    document.title = ( appMap[this.state.appName] || appMap['default'] ).pageTitle
    this.sensorsInit()
    const localTime = window.localStorage.getItem('PageTime') || 30
    if(parseInt(localTime) >= 0) {
      this.setState(() => ({
        time: parseInt(localTime)
      }))
    }
    const setTime = setInterval(() => {
      if(this.state.time > 0) {
        this.setState((preTime) => ({
          time: preTime.time-1
        }))
      }
      window.localStorage.setItem('PageTime', this.state.time)
      if(this.state.time <= 0) {
        clearInterval(setTime)
      }
    }, 1000)
    setTimeout(() => {
      this.setState(() => ({
        tip: 'tip'
      }))
    }, 1000);
  }
  render() {
    const { app, time, tip } = this.state
    const appState = appMap[app] || appMap['default'] // 每一个app对应的数据
    const appClass = 'register-coinlist ' + app
    const btnMsg = time > 0 ? `${ appState.btnMsg }(${ time })` : `${ appState.btnMsg }`
    const btnColor = time > 0 ? 'btnGray': 'btnBlue'

    return <div className={appClass}>
      <div className='header-title'>
        <h1>{ appState.tip }</h1>
        <p className='header-msg'>
          { appState.headerMsg }<br/>
          <a onClick={ this.pushRegister.bind(this) }>{ appState.headerATag}</a>
        </p>
      </div>

      <div className='register-step'>
        <RegisterStep appState={ appState }></RegisterStep>
      </div>
      <div className='register-footer'>
        <h2 className='footer-title'>{ appState.footerTitle }</h2>
        
        <ul dangerouslySetInnerHTML={{ __html: appState.footerContent }} className="footer-list"></ul>
        
        <button className={['register-btn', btnColor ].join(' ')} >
          <p style={{opacity: 0}}>{ tip }</p>
          <a onClick={ this.goToRegister.bind(this) } >{ btnMsg }</a>
        </button>
      </div>
    </div>
  }
}

export default RegisterCoinlist;